import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';

export default function setTitle({ locale = 'en', isWhiteLabel = false }) {
    const title = {
        cn: 'AI Lab - 智慧芽',
        en: 'AI Lab - PatSnap',
        jp: 'AI Lab - PatSnap',
        de: 'AI Lab - PatSnap',
        tw: 'AI Lab - 智慧芽',
    };
    document.title = replaceWhiteLabelTitle({ title: title[locale] || title['en'], isWhiteLabel });
}
